import {useEffect, useState} from 'react';

export function useWindowScroll() {
  const bodyOffset =
    typeof document !== 'undefined' ? document.body.getBoundingClientRect() : {top: 0, left: 0};
  const [scrollY, setScrollY] = useState(-bodyOffset.top);
  const [scrollX, setScrollX] = useState(bodyOffset.left);

  const listener = () => {
    const newBodyOfset = document.body.getBoundingClientRect();
    setScrollY(-newBodyOfset.top);
    setScrollX(newBodyOfset.left);
  };

  useEffect(() => {
    listener();
    window.addEventListener('scroll', listener);

    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, []);

  return {
    scrollY,
    scrollX
  };
}
